export default "__VITE_ASSET__qAk$u5JO__"